module.exports = __webpack_public_path__ + "static/media/20.79f54c74.jpg";